export default __webpack_public_path__ + "static/media/arrow-right-black.1115538b.svg";